<div class="app-wrapper">
	<div class="main overflow-hidden" id="htmlData">
		<ascedia-alert-banner 
			[options]="previewBanner"
			*ngIf="previewBanner$ | async as previewBanner;"
			[consoleLogs]="false"
			></ascedia-alert-banner>
		<ascedia-alert-banner 
			[options]="alertBanner"
			*ngIf="alertBanner$ | async as alertBanner;"
			></ascedia-alert-banner>
		<ascedia-navbar 
			imgSrc="assets/images/compass-tours-logo-color.svg"
			imgAlt="logo"
			className="navbar-expand-lg navbar-light bg-white hide-for-print" 
			[navItems]="navItems"
			[showArrows]="false"
			[userRole]="activeAccountRole$ | async"
			[userSubRole]="activeAccountTravelAdvisorPosition$ | async"
			[consoleLogs]="false"
			></ascedia-navbar>
		<div class="hidden" *ngIf="cart$ | async as cart">cart: {{cart | json}}</div>
		<!-- (activate)="onActivate($event)" -->
		<router-outlet></router-outlet>
		<footer-component></footer-component>
	</div>

	<app-confirm-dialog></app-confirm-dialog> 
	<app-travel-board></app-travel-board>
	<app-cookie-banner></app-cookie-banner>
	
</div>